var ClientVarsDomainMapInfo = /** @class */ (function () {
    function ClientVarsDomainMapInfo() {
    }
    ClientVarsDomainMapInfo.getLevel1MapInfo = function (docMeta, auth, user) {
        return {
            // docMeta->padInfo
            domainId: docMeta.docMetaEntity.padInfo.domainId,
            padId: docMeta.docMetaEntity.padInfo.padId,
            type: docMeta.docMetaEntity.padInfo.type,
            padType: docMeta.docMetaEntity.padInfo.padType,
            shareLink: docMeta.docMetaEntity.padInfo.shareLink,
            docStatus: docMeta.docMetaEntity.padInfo.docStatus,
            globalPadId: docMeta.docMetaEntity.padInfo.globalPadId,
            lastModifyUser: docMeta.docMetaEntity.padInfo.lastModifyUser,
            lastModifyTime: docMeta.docMetaEntity.padInfo.lastModifyTime,
            // docMeta->createInfo
            metaCreateTime: docMeta.docMetaEntity.createInfo.metaCreateTime,
            creatorId: docMeta.docMetaEntity.createInfo.creatorId,
            creatorNick: docMeta.docMetaEntity.createInfo.creatorNick,
            creatorDomain: docMeta.docMetaEntity.createInfo.creatorDomain,
            isCreator: docMeta.docMetaEntity.createInfo.isCreator,
            // docMeta->ownerInfo
            ownerId: docMeta.docMetaEntity.ownerInfo.ownerId,
            ownerNick: docMeta.docMetaEntity.ownerInfo.ownerNick,
            ownerAppid: docMeta.docMetaEntity.ownerInfo.ownerAppid,
            officialAuthInfo: docMeta.docMetaEntity.ownerInfo.officialAuthInfo,
            // docMeta->titleInfo
            padTitle: docMeta.docMetaEntity.titleInfo.title,
            title: docMeta.docMetaEntity.titleInfo.title,
            isUserChangeTitle: docMeta.docMetaEntity.titleInfo.isUserChangeTitle,
            // authInfo
            rightFlag: auth.authAggregate.authInfoEntity.selfRole,
            isOwner: auth.authAggregate.authInfoEntity.isOwner,
            // userInfo
            tinyid: user.userInfoAggregate.userInfo.tinyid,
            userName: user.userInfoAggregate.userInfo.nick,
            userPic: user.userInfoAggregate.userInfo.avatar,
            userType: user.userInfoAggregate.userInfo.loginType,
            userId: user.userInfoAggregate.userInfo.uid,
            uin: user.userInfoAggregate.userInfo.uin,
        };
    };
    ClientVarsDomainMapInfo.getLevel2PrivilegeMapInfo = function (auth) {
        var selfDocPrivilege = auth.authAggregate.authInfoEntity.selfDocPrivilege;
        return {
            can_copy: selfDocPrivilege.canCopy,
            can_print: selfDocPrivilege.canPrint,
            can_history: selfDocPrivilege.canHistory,
            can_read: selfDocPrivilege.canRead,
            can_edit_title: selfDocPrivilege.canEditTitle,
            can_search: selfDocPrivilege.canSearch,
            can_add_user: selfDocPrivilege.canAddUser,
            can_view_image: selfDocPrivilege.canViewImage,
            can_edit: selfDocPrivilege.canEdit,
            can_share: selfDocPrivilege.canShare,
            can_comment: selfDocPrivilege.canComment,
            can_about: selfDocPrivilege.canAbout,
            can_spit_slot: selfDocPrivilege.canSpitSlot,
            can_watermark: selfDocPrivilege.canWatermark,
            can_translate: selfDocPrivilege.canTranslate,
            can_link_exp: selfDocPrivilege.canLinkExp,
            can_copy_doc: selfDocPrivilege.canCopyDoc,
        };
    };
    ClientVarsDomainMapInfo.getLevel2AdvPolicyMapInfo = function (auth) {
        var selfDocAdvancedPrivilege = auth.authAggregate.authInfoEntity.selfDocAdvancedPrivilege;
        return {
            reader_can_comment: selfDocAdvancedPrivilege.readerCanComment,
            view_forbid_copy_print: selfDocAdvancedPrivilege.viewForbidCopyPrint,
            writer_can_comment: selfDocAdvancedPrivilege.writerCanComment,
        };
    };
    return ClientVarsDomainMapInfo;
}());
export { ClientVarsDomainMapInfo };
